/**
 * `canDismiss` callback of an `ion-modal` that stays open when swiped down.
 * The close buttons, a backdrop tap and a programmatic `dismiss()` still close it.
 * (`swipe-to-close` is not a property of Ionic 8 modals, only `canDismiss` stops the gesture.)
 */
export function canDismissExceptGesture(_data?: unknown, role?: string): boolean {
  return role !== "gesture";
}
